import { Link } from "react-router-dom";
import { useStateContext } from "../../Contexts/ContextProvider";

const Attendantrow = ({ attendant }) => {
  const { API } = useStateContext();

  return (
    <tr>
      <td className="ps-4">
        <img src={`${API}${attendant.image}`} alt={attendant.name} className="rounded-circle" style={{ width: 44, height: 44, objectFit: "cover" }} />
      </td>
      <td>
        <div className="fw-semibold">{attendant.name}</div>
        <div className="text-muted small">{attendant.email}</div>
      </td>
      <td>{attendant.position || "—"}</td>
      <td>{attendant.nationality || "—"}</td>
      <td>
        <span className="badge rounded-pill bg-light text-dark">{attendant.role || "Guest"}</span>
      </td>
      <td className="pe-4">
        <div className="d-flex flex-wrap gap-2">
          <Link to={`./${attendant.id}`} className="btn btn-sm btn-dark">
            Details
          </Link>
          <Link to={`./${attendant.id}/profile`} className="btn btn-sm btn-outline-danger">
            Profile
          </Link>
        </div>
      </td>
    </tr>
  );
};

export default Attendantrow;